import { render, staticRenderFns } from "./RDataTagCard.vue?vue&type=template&id=5ddd9b6e&scoped=true&"
import script from "./RDataTagCard.vue?vue&type=script&lang=js&"
export * from "./RDataTagCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataTagCard.vue?vue&type=style&index=0&id=5ddd9b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd9b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
